import React from 'react'
import '../../../App.scss';
import Grid from "@material-ui/core/Grid";
import {data} from "../../../Store/Actions/DataAction";
import {connect} from "react-redux";

import LightImage from '../../../assets/images/img_progress_light.png'
class PrizeProgress extends React.Component{
    constructor() {
        super()
        this.state={
            rxDataLoaded:false,
            interval:null,
            loaderPercentage:3,
        }
    }
    checkLoading=()=>{
        if (this.props.UserData.userData!=null)
            if (!this.state.rxDataLoaded){
                this.setState({
                    rxDataLoaded:true
                })
                clearInterval(this.state.interval)
            }
    }
    dataInterval=() =>{
        const interval =  setInterval(this.checkLoading, 100);
        this.setState({
            interval:interval
        });
    }
    componentDidMount() {
        this.dataInterval()

    }

    // componentDidUpdate() {
    //     if (this.props.UserData.userData!=null)
    //         if (!this.state.rxDataLoaded)
    //             this.setState({
    //                 rxDataLoaded:true
    //             })
    //     console.log('prize progress',this.state)
    // }

    render() {
    const data=this.props.UserData.userData
        const {rxDataLoaded}= this.state

    return (
            <Grid className="progress" alignItems={"center"} style={{position:'relative',height:'100%'}} container justify={"center"}
            >
                <Grid item className="progressbar"  container alignItems={"center"}>
                  <span style={{
                      // width:`${100/this.state.loaderPercentage}%`
                      width:rxDataLoaded?
                      `${(100/data.stats.max)*(data.stats.current)}%`:
                          '2'
                  }} >
                  </span>
                    <img style={{alignSelf:'center'}} className="progress-light-icon" src={LightImage} alt=""/>
                </Grid>
                <p className="progress-text">
                    {/*2/5*/}
                    {
                        rxDataLoaded?
                            `${data.stats.current}/${data.stats.max}`:
                            'loading'}

                </p>
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{data}) (PrizeProgress)